var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2282 14.9283L9.41485 15.7417C9.07044 16.0861 8.51354 16.0861 8.1728 15.7417L1.05029 8.62285C0.705892 8.27845 0.705892 7.72155 1.05029 7.38081L8.1728 0.258301C8.5172 -0.0861003 9.07411 -0.0861003 9.41485 0.258301L10.2282 1.07167C10.5763 1.41974 10.569 1.98763 10.2136 2.32837L5.79863 6.53446H16.3285C16.8158 6.53446 17.2078 6.92649 17.2078 7.41379V8.58622C17.2078 9.07351 16.8158 9.46554 16.3285 9.46554H5.79863L10.2136 13.6716C10.5726 14.0124 10.5799 14.5803 10.2282 14.9283Z",
    fill: "#803F3A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowBack);
export default __webpack_public_path__ + "static/media/ArrowBack.836ae4a133369360e4ffc25d9847b4e8.svg";
export { ForwardRef as ReactComponent };